import { FC } from "react";

import { ReleaseLabelSelectorProps } from "./types";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const ReleaseLabelSelector: FC<ReleaseLabelSelectorProps> = ({
  selectedReleaseLabel,
  availableReleaseLabelsList,
  onReleaseLabelSelect,
}) => (
  <div className="space-y-2">
    <label className="block text-sm font-medium text-gray-700">
      Release Label for Prompt Template
    </label>
    <DropdownMenu>
      <DropdownMenuTrigger className="w-full rounded-md border border-gray-300 bg-white px-4 py-2 text-left text-sm shadow-sm transition-colors hover:bg-gray-50 focus:border-blue-500 focus:outline-none focus:ring-1 focus:ring-blue-500">
        <span className={selectedReleaseLabel ? "text-gray-900" : "text-gray-500"}>
          {selectedReleaseLabel || "Select a release label"}
        </span>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="start"
        className="max-h-60 w-[--radix-dropdown-menu-trigger-width] overflow-auto"
      >
        {availableReleaseLabelsList.map(releaseLabel => (
          <DropdownMenuItem key={releaseLabel} onSelect={() => onReleaseLabelSelect(releaseLabel)}>
            {releaseLabel}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  </div>
);

export default ReleaseLabelSelector;
